import React from "react";
import PaymentSummaryContent from "./PaymentSummaryContent";
import { PaymentSummaryDialogProps } from "./types";
import { useBusinessTheme } from "src/shared/hooks/useBusinessTheme";
import { ModalWrapper } from "src/shared/components/ModalWrapper";
import CommonButtons from "src/shared/components/CommonButtons";

const PaymentSummaryDialog: React.FC<PaymentSummaryDialogProps> = ({
  open,
  onClose,
  onBack,
  onCompletePayment,
  isProcessing,
  paymentMethod,
  receivedAmount,
  selectedProducts,
  selectedStaff,
  customerName,
  customerPhone,
  discount,
  tipsAmount,
  onReceivedAmountChange,
  time,
  outstandingBalance,
  isLoadingOutstanding = false,
}) => {
  const { loading } = useBusinessTheme();

  if (!open || loading) return null;

  const isCashLikePayment = paymentMethod?.toLowerCase() === "cash" || paymentMethod?.toLowerCase() === "card";

  const isButtonDisabled = isProcessing || (isCashLikePayment && (!receivedAmount || parseFloat(receivedAmount) <= 0));

  const handleCompletePayment = async () => {
    onClose();
    try {
      await Promise.resolve(onCompletePayment());
    } catch (err) {
      console.error("Payment completion failed:", err);
    }
  };

  return (
    <ModalWrapper title="Payment Summary" onClose={onClose} onBack={onBack} showCloseButton showBackButton width="max-w-md">
      <div className="flex flex-col bg-white">
        <div className="px-3 py-3 overflow-y-auto scrollbar-hide">
          <PaymentSummaryContent
            selectedProducts={selectedProducts}
            selectedStaff={selectedStaff}
            customerName={customerName}
            customerPhone={customerPhone}
            discount={discount}
            tipsAmount={tipsAmount}
            onReceivedAmountChange={onReceivedAmountChange}
            time={time}
            paymentMethod={paymentMethod}
            receivedAmount={receivedAmount}
            outstandingBalance={outstandingBalance}
            isLoadingOutstanding={isLoadingOutstanding}
          />
        </div>

        <div className="border-t border-gray-200 px-3 py-2 flex justify-end gap-3">
          <CommonButtons label="Close" variant="outlineDanger" onClick={onClose} className="w-32 h-10 rounded-full" />

          <CommonButtons label={isProcessing ? "Processing..." : isLoadingOutstanding ? "Loading..." : "Complete"}  onClick={handleCompletePayment} disabled={isButtonDisabled} className="w-32 h-10 rounded-full" />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default PaymentSummaryDialog;
